var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 100,
    height: 100,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "DIkTyBMFZwUEEOM1rIQ4aa_FnhiFHcPQyOa_gr1",
    x1: -1.206,
    x2: 28.667,
    y1: 7.528,
    y2: 52.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f24707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#f24f07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f26207"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#DIkTyBMFZwUEEOM1rIQ4aa_FnhiFHcPQyOa_gr1)",
    d: "M22,42H12c-1.657,0-3-1.343-3-3v-6c0-1.657,1.343-3,3-3h13v9C25,40.657,23.657,42,22,42z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "DIkTyBMFZwUEEOM1rIQ4ab_FnhiFHcPQyOa_gr2",
    x1: 9.371,
    x2: 39.243,
    y1: 0.507,
    y2: 45.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f24707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#f24f07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f26207"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#DIkTyBMFZwUEEOM1rIQ4ab_FnhiFHcPQyOa_gr2)",
    d: "M22,6H12c-1.657,0-3,1.343-3,3v6 c0,1.657,1.343,3,3,3h13V9C25,7.343,23.657,6,22,6z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "DIkTyBMFZwUEEOM1rIQ4ac_FnhiFHcPQyOa_gr3",
    x1: 14.118,
    x2: 43.99,
    y1: -2.644,
    y2: 42.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f24707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#f24f07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f26207"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#DIkTyBMFZwUEEOM1rIQ4ac_FnhiFHcPQyOa_gr3)",
    d: "M37,30H25V18h12c1.657,0,3,1.343,3,3v6 C40,28.657,38.657,30,37,30z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplit);
export default __webpack_public_path__ + "static/media/replit.55450c098276e9884f95458184c86486.svg";
export { ForwardRef as ReactComponent };